import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {
    FileAttachment,
    FileAttachmentsV1Service,
    Barrel,
    BarrelsV1Service
} from "../../../apis/backend";
import {firstValueFrom, mergeMap} from "rxjs";
import {
    BarrelDialogComponent,
} from "../dialog/barrel-dialog.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileAttachmentComponent} from "../../../components/file-attachments/file-attachment/file-attachment.component";
import {WoodTypeDisplayValues} from "../utils/wood-type";
import {ToastLevelDisplayValues} from "../utils/toast-level";

@Component({
    selector: 'barrel',
    templateUrl: './barrel-detail.component.html',
})
export class BarrelDetailComponent implements OnInit {
    
    public Barrel: Barrel;

    protected readonly ToastLevelDisplayValues = ToastLevelDisplayValues;
    protected readonly WoodTypeDisplayValues = WoodTypeDisplayValues;
    
    public EditMode = false;
    
    constructor(private _fileAttachmentService: FileAttachmentsV1Service,
                private _barrelService: BarrelsV1Service,
                private _modalService: NgbModal,
                private _route: ActivatedRoute) {}
    
    ngOnInit() {
        this._route.params.pipe(
            mergeMap(params => {
                return this._barrelService.getBarrel(params['barrelID']);
            })
        )
            .subscribe(barrel => {
                this.Barrel = barrel;
            });
    }

    public EditBarrel() {
        if (this.Barrel) {
            let barrel = <Barrel>JSON.parse(JSON.stringify(this.Barrel));

            let modal = this._modalService.open(BarrelDialogComponent, { size: 'lg' });
            modal.componentInstance.Barrel = barrel;

            modal.result
                .then((barrel: Barrel) => {
                    return firstValueFrom(this._barrelService.updateBarrel(barrel.BarrelID, barrel));
                })
                .then((barrel: Barrel) => {
                    this.Barrel = barrel;
                });
        }
    }
}